import AddRoundedIcon from '@mui/icons-material/AddRounded'
import { Stack } from '@mui/material'
import { ButtonSecondary } from 'components/ButtonSecondary'
import React, { useEffect } from 'react'
import { Control, useFieldArray, UseFormSetValue, UseFormWatch } from 'react-hook-form'
import { personAddressInit } from 'types/address.type'
import { HearingIdentificationType } from 'types/hearing-identification.type'
import { AddressItem } from './components/AddressItem'
import { useHearingIdentificationBlockFieldsContext } from 'contexts/hearing-identification-block-fields.context'

type AddressListProps = {
  control: Control<HearingIdentificationType>
  watch: UseFormWatch<HearingIdentificationType>
  setValue: UseFormSetValue<HearingIdentificationType>
}

export const AddressList: React.FC<AddressListProps> = ({ control, watch, setValue }) => {
  const { isBlockedFields } = useHearingIdentificationBlockFieldsContext()
  const {
    fields: addressesFields,
    append: handleAddAddress,
    remove: handleRemoveAddress,
  } = useFieldArray({
    control,
    name: 'enderecos',
  })

  const addressesValues = watch('enderecos')

  useEffect(() => {
    if (addressesValues && !addressesValues.length) {
      setValue('enderecos', [personAddressInit], { shouldDirty: false })
    }

    if (addressesValues && addressesValues.length > 1) {
      const hasPrincipal = addressesValues.find((item) => item.enderecoPrincipal === 'S')
      if (!hasPrincipal) {
        setValue(`enderecos.0.enderecoPrincipal`, 'S', { shouldDirty: true })
      }
    }
  }, [addressesValues])

  return (
    <>
      {addressesFields.map((_, i) => (
        <AddressItem
          key={i}
          index={i}
          control={control}
          watch={watch}
          setValue={setValue}
          listValues={addressesValues}
          onRemove={handleRemoveAddress}
        />
      ))}
      <Stack sx={{ ml: 2, width: '100%' }}>
        <ButtonSecondary
          maxWidth={150}
          startIcon={<AddRoundedIcon />}
          label='Endereço'
          disabled={isBlockedFields}
          onClick={() => handleAddAddress(personAddressInit)}
        />
      </Stack>
    </>
  )
}
